import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoryHeirarchy } from '../../redux/getCategoryHeirarchy';
import InformationHeader from '../../component/reusable/informationHeader/InformationHeader';
import ViewProductForm from '../../component/productsComps/ViewProductForm';
import { exportManufacturerThunk } from '../../redux/manufacturer/getAllManufacturerSlice';
import { getAttributesAddProdThunk, getProductDetails, getProductThunk } from '../../redux/productSlice';
import { useParams } from 'react-router-dom';

const ViewProduct = () => {

  const { productDetails, loading } = useSelector(state => state.products)

  const dispatch = useDispatch();
  const { id } = useParams()
  useEffect(() => {
    dispatch(getCategoryHeirarchy());
    dispatch(exportManufacturerThunk())
    dispatch(getAttributesAddProdThunk())
    dispatch(getProductThunk())
    dispatch(getProductDetails(id))
  }, []);

  return (
    <div >
      <InformationHeader
        mainpage="Dashboard"
        prevpage="Product"
        pagename="View Product"
        buttonText="Save"
      />
      <ViewProductForm productDetails={productDetails} loadings={loading} />
    </div>
  );

};

export default ViewProduct;
